export default [
  {
    path: "/bi-dashboard",
    name: "bi-main",
    component: () => import("../../modules/BI/BIDashboard.vue"),
    meta: {
      auth: true,
      layout: "main",
      role: ["bi", "academy"],
    },
  },
];
